import Spinner from 'src/javascripts/components/utilities/Spinner';

export default class SurveysSectionsIndex {

  constructor() {}

  render() {

    // Draggable sections https://api.jqueryui.com/sortable
    $('.survey-sections-sortable').sortable({
      placeholder: "available-section-space",
      scrollSensitivity: 100,
      cursor: "move",
      handle: ".grip",
      items: "li:not(.unsortable)",
      start: function(event, ui) {
        $('.section-action-buttons .btn').css('opacity', 0);
        $('.section-title').addClass('show');
      },
      stop: function(event, ui) {
        $('.section-action-buttons .btn').css('opacity', 1);
        $('.section-title').removeClass('show');
      },
      update: function(event, ui) {
        let sortOrder = $(this).sortable('toArray');
        let accountUrl = $('body').attr('data-account-url');
        let surveySlug = $('.survey-sections-sortable').attr('data-slug');
        let url = '/' + accountUrl + '/surveys/' + surveySlug + '.json?';
        let params = {};
        params['survey'] = {};
        params['survey']['sections_attributes'] = {};
        $.each(sortOrder, function(ind, sectionId) {
          let id = $('#' + sectionId).attr('data-section-id');
          params['survey']['sections_attributes'][ind] = {};
          params['survey']['sections_attributes'][ind]['id'] = id;
          params['survey']['sections_attributes'][ind]['sort_order'] = ind + 1;
        });
        $.ajax({
          type: 'PATCH',
          dataType: 'application/json',
          url: url + $.param(params),
          complete(result) { 
            let responseText = JSON.parse(result.responseText);
          },
        });
      }
    });

    // Import poll
    let importPoll = () => {

      // Get generating message on page
      let isGenerating = $('.generating-message');

      // Only continue if status indicator present (if should poll for recs is true)
      if (isGenerating.length !== 0) {

        // Set Api url to get data
        let accountUrl = isGenerating.attr('data-account-url');
        let surveySlug = isGenerating.attr('data-slug');
        let url = '/' + accountUrl + '/surveys/' + surveySlug + '/check_import_status.js?';

        // Execute ajax request (using js erb template to render content so can control profile styling more easily)
        // Must specify '.js' otherwise processes as JSON
        $.ajax({
          type: "POST",
          dataType: "application/json",
          timeout: 3000,
          url: url,
          complete(result) { 
            let status = JSON.parse(result.responseText);
            if (status['processing'] === false) {
              return Turbo.visit(window.location.href);
            } else {
              setTimeout(function() { importPoll() }, 4000);
            }
          }
        });
      }
    };

    // Poll server for status of mapped items, if generating message present
    if ($('.generating-message').length !== 0) { importPoll(); }


  }

}